<div id="head_wrap">
    <div id="closeBtn">
        <span  (click)="close();">×</span>
    </div>

    <h1 id="title">{{report.reports[currentIndex].name}}分析报告</h1>
</div>

<div id="wrap">
    <!--<app-expert-hints [isExcellent]="false" [summary]="sentence"></app-expert-hints>-->
    <app-expert-hints [isExcellent]="false" [title]="expert_title" [content]="expert_content" [activity]="true"></app-expert-hints>

    <div id="report">
       <!-- <h2>提供支持</h2>
        <p>通过向下属分享改进建议、最佳做法、发展资源、正面示范或建议尝试新做法，来辅导下属。</p>
        <h2>指定行动计划</h2>
        <p>总结个人将采取的具体行动；分配明确的职责、时间表、进展衡量指标和跟进日期。</p>-->

        <p>下属总是迟到，背后的原因可能千奇百怪，使用KP3“寻求帮助，鼓励参与”通过提问和他澄清原因，引导他的思维，最终鼓励其承担责任才是关键。</p>

        <!--<button id="detailBtn" (click)="onDetailBtnClick()">{{report.reports[currentIndex].name}}答案解析</button>-->
        <button id="detailBtn" (click)="onDetailBtnClick()">答案解析</button>
        <button id="againBtn" (click)="redo()" >再做一次</button>
    </div>

    <!--<div id="prompt" *ngIf="report.allQuizFinished === true && currentIndex === report.totalQuizCount - 1">
        <div id="prompt_picture">

        </div>

        <p>
            完成巩固练习，<br/>
            你将进入情景模拟环节。
        </p>
        <p>
            每周解锁一场情景模拟，<br/>
            还原真实的案例场景，<br/>
            将课程所学内化为能力提升。
        </p>
        <p>
            每周解锁一场情景模拟，<br/>
            还原真实的案例场景，<br/>
            将课程所学内化为能力提升。
        </p>
        <p>
            第一次情景模拟开放时间：<br/>
            <span>{{report.nextExerciseStartTime}}</span>
        </p>
    </div>-->
</div>

<button id="choiceBtn" *ngIf="currentIndex === report.finishedQuizCount + report.finishedExerciseCount - 1" class="choiceBtn_enable" (click)="startNextCase()">
    下一题
</button>


<div id="smallReportAnswer">
    <h1>答案解析</h1>
    <div class="smallReportAnswerWord fontSize14 lineHeight21">
        在本案例中，如果你熟练使用KP3的技巧，那么在辅导能力中的“明确表达绩效挑战”和”促进参与”这2个关键行动将会展现的非常好。
    </div>
    <div class="smallReportAnswerWord fontSize14 lineHeight21">
        在之后的情景模拟中，将会对你辅导能力的7个关键行动品鉴哦，请使用好课程所教授的各种技巧吧。
    </div>
    <div class="smallReportAnswerWord fontSize14 lineHeight21 smallReportAnswerSubtitle">
        本次练习正确答案
    </div>
    <div class="smallReportAnswerWord fontSize14 lineHeight21">
        1. 寒暄过后，你切入正题，开始和小吕探讨他近期的工作表现。
    </div>
    <div class="smallReportAnswerWord fontSize14 lineHeight21">
        <span class="correctAnswer">正确答案：</span>你上周出现了连续几次迟到，我想了解一下是什么原因？
    </div>
    <div class="smallReportAnswerWord fontSize14 lineHeight21">
        <span class="analysis">解析：</span>非常好！这是一个标准的开放式澄清问题。你可以通过这个问题挖掘出下属迟到背后的原因。
    </div>
    <div class="smallReportAnswerWord fontSize14 lineHeight21">
        2. 小吕：上周连续几天下雨，其实我也挺着急的，早晨总是堵车。时间真的不太好控制。
    </div>
    <div class="smallReportAnswerWord fontSize14 lineHeight21">
        <span class="correctAnswer">正确答案：</span>上周连续下雨，确实时间很难控制，我当然能够理解的。但是你觉得周围的同事们会怎么看待你迟到？
    </div>
    <div class="smallReportAnswerWord fontSize14 lineHeight21">
        <span class="analysis">解析：</span>非常好！你通过这次提问，引导下属从旁观者的角度看待自己迟到会带来哪些影响。
    </div>
    <div class="smallReportAnswerWord fontSize14 lineHeight21">
        3. 小吕：老板。我明白频繁迟到确实容易给同事留下不好的映像。我接下来一定努力避免。
    </div>
    <div class="smallReportAnswerWord fontSize14 lineHeight21">
        <span class="correctAnswer">正确答案：</span>你明白我就放心了。你觉得具体有什么办法可以避免迟到呢？
    </div>
    <div class="smallReportAnswerWord fontSize14 lineHeight21">
        <span class="analysis">解析：</span>非常好！你通过提问，促进下属一起找方法。他会更有动力把这个办法用下去。
    </div>
</div>

<div id="closeBtnReport" (click)="onCloseBtnReportClick()"></div>
<div id="shade"></div>

<app-report-list-button [reports]="report.reports" (onSwitchReport)="switchReport($event);"></app-report-list-button>


// WEBPACK FOOTER //
// ./src/app/case-practice-report-small/case-practice-report-small.component.html